import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { KioskInputType } from 'hooks/kiosk/useKiosk';
import { Subject } from 'utils/subject';
import {
  KioskButtonRowGroup,
  KioskEntryButton,
  KioskEntryInput,
  KioskEntryMessageBoxStyled,
  KioskRowGroup,
} from 'containers/public/kiosk/Kiosk.styled';
import { KioskLayout } from 'containers/public/kiosk/KioskLayout';
import { useKioskPhoneEntryInput } from './hooks/useKioskPhoneEntry';
import { useKioskPhoneEntryForm } from './hooks/useKioskPhoneEntryForm';
import { KioskTextInputHintWrap } from './KioskInputHynt';

export const KioskEntryPhone = ({
  onPhone,
  onDifferentInputClicked,
  onUserActivity,
  resetEvent,
}: {
  onPhone: (phone: string) => any;
  onDifferentInputClicked: (inputType: KioskInputType) => void;
  onUserActivity: () => void;
  resetEvent: Subject<void>;
}) => {
  const { t } = useCommonTranslation();

  const { register, onSubmit, isValid } = useKioskPhoneEntryForm({
    onPhoneSubmitted: onPhone,
    onUserActivity,
    resetEvent,
  });

  const { inputConfigs } = useKioskPhoneEntryInput({
    register,
    onUserActivity,
  });

  return (
    <KioskLayout>
      <KioskEntryMessageBoxStyled>
        <KioskTextInputHintWrap inputHint={t('kiosk-checkin-phone-hint')}>
          <form onSubmit={onSubmit}>
            <KioskRowGroup>
              {inputConfigs.map((cfg) => (
                <KioskEntryInput
                  key={cfg.name}
                  style={cfg.style}
                  type="text"
                  maxLength={cfg.maxLength}
                  minLength={cfg.minLength}
                  placeholder={cfg.placeholder}
                  onKeyDown={cfg.onKeyDown}
                  {...cfg.props}
                />
              ))}
            </KioskRowGroup>
          </form>
        </KioskTextInputHintWrap>

        <KioskButtonRowGroup>
          <KioskEntryButton
            type="button"
            variant="secondary"
            onClick={() => onDifferentInputClicked('BIRTHDATE')}
          >
            {t('kiosk-checkin-birthdate-surname-initial')}
          </KioskEntryButton>
          <KioskEntryButton
            type="submit"
            variant="primary"
            onClick={onSubmit}
            disabled={!isValid}
          >
            {t('next')}
          </KioskEntryButton>
        </KioskButtonRowGroup>
      </KioskEntryMessageBoxStyled>
    </KioskLayout>
  );
};
